/**
 * Lightweight split-text utilities — no GSAP Club plugin needed.
 * Splits a text element into spans for character or word-level animation.
 */

export function splitChars(el: HTMLElement, text: string | null = null): HTMLSpanElement[] {
  const source = text ?? el.textContent ?? ''
  el.innerHTML = ''
  const spans: HTMLSpanElement[] = []
  for (const ch of Array.from(source)) {
    const span = document.createElement('span')
    if (ch === ' ') {
      span.className = 'char space'
      span.innerHTML = '&nbsp;'
    } else {
      span.className = 'char'
      span.textContent = ch
    }
    el.appendChild(span)
    spans.push(span)
  }
  return spans
}

export function splitWords(el: HTMLElement, text: string | null = null): HTMLSpanElement[] {
  const source = text ?? el.textContent ?? ''
  el.innerHTML = ''
  const spans: HTMLSpanElement[] = []
  const words = source.split(/(\s+)/)
  for (const token of words) {
    if (token.match(/^\s+$/)) {
      el.appendChild(document.createTextNode(' '))
      continue
    }
    const word = document.createElement('span')
    word.className = 'word'
    // Inner wrapper so we can clip+reveal from underneath
    const inner = document.createElement('span')
    inner.className = 'word-inner'
    inner.textContent = token
    word.appendChild(inner)
    el.appendChild(word)
    spans.push(word)
  }
  return spans
}

/** Split into letters but keep the word unit intact (so letters wrap together). */
export function splitLetters(el: HTMLElement, text: string | null = null): HTMLSpanElement[] {
  const source = text ?? el.textContent ?? ''
  el.innerHTML = ''
  const letters: HTMLSpanElement[] = []
  const words = source.split(' ')
  words.forEach((word, wi) => {
    const wordEl = document.createElement('span')
    wordEl.className = 'word'
    wordEl.style.display = 'inline-block'
    wordEl.style.whiteSpace = 'nowrap'
    for (const ch of Array.from(word)) {
      const letter = document.createElement('span')
      letter.className = 'letter'
      letter.style.display = 'inline-block'
      letter.textContent = ch
      wordEl.appendChild(letter)
      letters.push(letter)
    }
    el.appendChild(wordEl)
    if (wi < words.length - 1) el.appendChild(document.createTextNode(' '))
  })
  return letters
}
